export const MATRIX_DATA_SUCCESS = 'MATRIX_DATA_SUCCESS';
export const GET_MATRIX = 'GET_MATRIX';
export const FETCH_MATRIX_LIST_SUCCESS = 'FETCH_MATRIX_LIST_SUCCESS';
export const FETCH_MATRIX_TITLES_SUCCESS = 'FETCH_MATRIX_TITLES_SUCCESS';
